import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'action-confirmation-dialog',
  imports: [ButtonModule, TranslatePipe],
  templateUrl: 'action-confirmation-dialog.html',
  styleUrl: './action-confirmation-dialog.scss',
})
export class ActionConfirmationDialog {
  constructor(
    public dialogRef: DynamicDialogRef<ActionConfirmationDialog>,
    public config: DynamicDialogConfig<ActionConfirmationInfo>,
  ) {}

  closeDialog(action: string) {
    this.dialogRef.close(action);
  }

  static openDialog(dialog: DialogService, dialogData: ActionConfirmationInfo) {
    return new Promise<string>((resolve, reject) => {
      const dialogRef = dialog.open(ActionConfirmationDialog, {
        header: dialogData.title,
        modal: true,
        width: '42rem',
        breakpoints: {
          '800px': '75vw',
          '575px': '90vw',
        },
        data: dialogData,
      });

      dialogRef.onClose.subscribe((result) => {
        console.log(`Dialog result: ${result}`);
        resolve(result);
      });
    });
  }
}

export interface ActionConfirmationInfoAction {
  action: string;
  title: string;
  severity?: undefined | 'primary' | 'warn' | 'danger';
}

export class ActionConfirmationInfo {
  title: string;
  message: string;
  actions: ActionConfirmationInfoAction[];

  constructor(title: string, message: string, actions: ActionConfirmationInfoAction[]) {
    this.title = title;
    this.message = message;
    this.actions = actions;
  }

  static yesno_nocol: ActionConfirmationInfoAction[] = [
    { action: 'no', title: 'general.no' },
    { action: 'yes', title: 'general.yes' },
  ];
  static yesno_yprim: ActionConfirmationInfoAction[] = [
    { action: 'no', title: 'general.no' },
    { action: 'yes', title: 'general.yes', severity: 'primary' },
  ];
  static yesno_nprim: ActionConfirmationInfoAction[] = [
    { action: 'yes', title: 'general.yes' },
    { action: 'no', title: 'general.no', severity: 'primary' },
  ];
  static yesno_ywarn: ActionConfirmationInfoAction[] = [
    { action: 'no', title: 'general.no' },
    { action: 'yes', title: 'general.yes', severity: 'warn' },
  ];
  static yesno_nwarn: ActionConfirmationInfoAction[] = [
    { action: 'yes', title: 'general.yes' },
    { action: 'no', title: 'No', severity: 'warn' },
  ];
  static yesno_ydanger: ActionConfirmationInfoAction[] = [
    { action: 'no', title: 'general.no' },
    { action: 'yes', title: 'general.yes', severity: 'danger' },
  ];
  static yesno_ndanger: ActionConfirmationInfoAction[] = [
    { action: 'yes', title: 'general.yes' },
    { action: 'no', title: 'general.no', severity: 'danger' },
  ];
}
